import {List} from 'immutable';

import {addToast} from '@albert-io/atomic';
import {
  getClassroomIndiePracticeSubjectsQuery,
  getIndiePracticeSubjectsQuery
} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import type {SubjectModelV2} from '@albert-io/models';
import {useStudentHomepageStore} from '../../useStudentHomepageStore';

export default function useIndependentPracticeSubjects() {
  const areIndependentPracticeSubjectsLoading = useStudentHomepageStore(
    (state) => state.areIndependentPracticeSubjectsLoading
  );
  const independentPracticeSubjects = useStudentHomepageStore(
    (state) => state.independentPracticeSubjects
  );
  const setAreIndependentPracticeSubjectsLoading = useStudentHomepageStore(
    (state) => state.setAreIndependentPracticeSubjectsLoading
  );
  const setIndependentPracticeSubjects = useStudentHomepageStore(
    (state) => state.setIndependentPracticeSubjects
  );

  function fetchIndependentPracticeSubjects(classroomId: string | undefined) {
    setAreIndependentPracticeSubjectsLoading(true);

    const query = classroomId
      ? getClassroomIndiePracticeSubjectsQuery(classroomId)
      : getIndiePracticeSubjectsQuery();

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((result: List<SubjectModelV2>) => {
        const filteredSubjects = result.toArray().filter((subject) => !subject.isAdaptive());
        setIndependentPracticeSubjects(filteredSubjects);
      })
      .catch(() => {
        addToast({
          color: 'negative',
          message: 'Failed to load independent practice subjects.'
        });

        setIndependentPracticeSubjects([]);
      })
      .finally(() => {
        setAreIndependentPracticeSubjectsLoading(false);
      });
  }

  return {
    areIndependentPracticeSubjectsLoading,
    fetchIndependentPracticeSubjects,
    independentPracticeSubjects
  };
}
